import { Suspense, lazy } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

import Spinner from 'src/components/common/spinner'
import { APP_ENV } from 'src/env'

import ErrorBoundary from './errorboundary'

const SignupPage = lazy(() => import('./signup'))

const SignupViewContainer = () => (
    <div>
        <Suspense fallback={<Spinner />}>
            <ErrorBoundary>
                <GoogleReCaptchaProvider
                    reCaptchaKey={APP_ENV.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY}
                >
                    <SignupPage />
                </GoogleReCaptchaProvider>
            </ErrorBoundary>
        </Suspense>
    </div>
)

export default SignupViewContainer
